var $3e76f0c5e221b5d0$exports = {};
/*
 * @Descripttion:
 * @Author: lqzh
 * @Date: 2020-02-28 16:31:28
 * @LastEditTime: 2026-05-19 09:14:05
 */ const { axios: $3e76f0c5e221b5d0$var$axios } = window;
if ('ontouchstart' in document) {
    document.body.addEventListener('touchstart', $3e76f0c5e221b5d0$var$showMap, true);
    document.body.addEventListener('touchend', $3e76f0c5e221b5d0$var$hideMap, true);
} else {
    document.body.addEventListener('mouseup', $3e76f0c5e221b5d0$var$hideMap, true);
    document.body.addEventListener('mousedown', $3e76f0c5e221b5d0$var$showMap, true);
}
document.body.addEventListener('contextmenu', (e)=>{
    e.preventDefault();
});
$3e76f0c5e221b5d0$var$axios.get('//api.zhuzhou.city/fun/people2/daily/json').then((res)=>{
    if (res.data.statusCode != 200) throw new Error(res.data.msg);
    document.querySelector('#ajaxDes').textContent = res.data.result.title + '...';
    document.querySelector('.top').dataset.src = res.data.result.link;
});
let $3e76f0c5e221b5d0$var$todayPic = `//api.zhuzhou.city/fun/people2/daily/pic?${new Date().toLocaleDateString().replace(/\//g, '')}`;
const $3e76f0c5e221b5d0$var$imgElm = document.querySelector('.cover');
$3e76f0c5e221b5d0$var$imgElm.onerror = ()=>{
    $3e76f0c5e221b5d0$var$imgElm.onerror = null;
    const fullback = './img/404.jpg';
    $3e76f0c5e221b5d0$var$imgElm.setAttribute('src', fullback);
    document.querySelector('.slogan').style['background-image'] = `url(${fullback})`;
};
$3e76f0c5e221b5d0$var$imgElm.setAttribute('src', $3e76f0c5e221b5d0$var$todayPic);
document.querySelector('.slogan').style['background-image'] = `url(${$3e76f0c5e221b5d0$var$todayPic})`;
let $3e76f0c5e221b5d0$var$timer = 0;
function $3e76f0c5e221b5d0$var$showMap(event) {
    clearTimeout($3e76f0c5e221b5d0$var$timer);
    $3e76f0c5e221b5d0$var$timer = setTimeout(()=>{
        event.stopPropagation();
        event.preventDefault();
        document.body.classList.add('showMap');
        console.log('down', event.type);
    }, 500);
}
function $3e76f0c5e221b5d0$var$hideMap(event) {
    clearTimeout($3e76f0c5e221b5d0$var$timer);
    document.body.classList.remove('showMap');
    console.log('up', event.type);
}
function $3e76f0c5e221b5d0$var$openSite(type) {
    switch(type){
        case 'p2':
            window.open(document.querySelector('.top').dataset.src);
            break;
        case 'bike':
            window.open('//bike.zhuzhou.city');
            break;
        case 'parking':
            window.open('//parking.zhuzhou.city');
            break;
        case 'bus':
            window.open('/bus/');
            break;
        case 'wc':
            window.open('//wc.zhuzhou.city');
            break;
    }
}
window.openSite = $3e76f0c5e221b5d0$var$openSite;


//# sourceMappingURL=Index.35c38236.js.map
